import React from "react";
// import { useNavigate } from "react-router-dom";
import {
  initial_values,
  validationSchema,
} from "../../../FormValidations/AccountManagementSchema";
import { useFormik } from "formik";
import CustNotificationsSettings from "../../../sections/CustomerDashboard/Settings/CustNotificationsSettings";
import DashboardMainContainer from "../../../components/common/Containers/DashboardMainContainer";

const CustomerNotifications = () => {
  const formik = useFormik({
    initialValues: initial_values,
    validationSchema: validationSchema,
    onSubmit: (values, { resetForm }) => {},
  });
  return (
    <>
      <DashboardMainContainer className={"!bg-white"}>
        <div className="min-h-screen">
          <form onSubmit={formik.handleSubmit}>
            <CustNotificationsSettings />
          </form>
        </div>
      </DashboardMainContainer>
    </>
  );
};

export default CustomerNotifications;
